// src/modules/Courier/pages/Route/RouteInfo/RouteInfo.jsx
import React, { useState } from 'react';
import { useRouteStore }    from '../useRouteStore';
import styles              from './RouteInfo.module.css';

export default function RouteInfo() {
  // Подписка на весь объект маршрута в zustand
  const route = useRouteStore(s => s.routeData);

  const [expanded, setExpanded] = useState(false);

  if (!route) return null;

  const {
    route_number,
    route_date,
    route_districts,
    time_from, time_to,
    driver, loader1, loader2,
    car, operator, route_status,
    receipts = [],
  } = route;

  // Формат даты DD.MM.YY
  const formattedDate = new Date(route_date).toLocaleDateString('ru-RU', {
    day:   '2-digit',
    month: '2-digit',
    year:  '2-digit',
  });

  const total      = receipts.length;
  const delivered   = receipts.filter(r => r.status === 'Закрыта').length;
  const inProgress  = receipts.filter(r => r.status === 'Открыта').length;
  const undelivered = receipts.filter(r => r.status === 'Не доставлено').length;

  const notNeeded = new Set(["ПоСчету","Кредит","Взаимозачет","Дилер","БезОплаты"]);
  const eligibleForCheck   = receipts.filter(r =>
    !notNeeded.has(r.payment_type) && r.status !== 'Не доставлено'
  );
  const checksIssuedCount  = eligibleForCheck.filter(r => r.is_check_issued).length;
  const eligibleCount      = eligibleForCheck.length;

  const pct = n => total > 0 ? `${(n / total * 100).toFixed(1)}%` : '0%';

  return (
    <div className={styles.container}>
      {/* header */}
      <div
        className={styles.clickableHeaderader}
        onClick={() => setExpanded(e => !e)}
      >
        <h2 className={styles.title}>
          Маршрут №{route_number} от {formattedDate}
        </h2>
        <div className={expanded ? styles.chevronUp : styles.chevronDown}/>
      </div>

      {/* progress bar always visible */}
      <div className={styles.progressWrapper}>
        <div className={styles.progressBar}>
          <div
            className={styles.filledDelivered}
            style={{ width: pct(delivered) }}
          />
          <div
            className={styles.filledInProgress}
            style={{ width: pct(inProgress) }}
          />
          <div
            className={styles.filledUndelivered}
            style={{ width: pct(undelivered) }}
          />
        </div>
      </div>

      {/* details when expanded */}
      {expanded && (
        <>
          <div className={styles.row}><b>Районы:</b> {route_districts}</div>
          <div className={styles.row}><b>Время:</b> {time_from} &ndash; {time_to}</div>
          <div className={styles.row}><b>Водитель:</b> {driver}</div>
          <div className={styles.row}><b>Грузчики:</b> {loader1}, {loader2}</div>
          <div className={styles.row}><b>Машина:</b> {car}</div>
          <div className={styles.row}><b>Оператор:</b> {operator}</div>
          <div className={styles.row}><b>Статус:</b> {route_status}</div>

          <div className={styles.stats}>
            <span>Открыта: {inProgress} ({pct(inProgress)})</span>
            <span>Закрыта: {delivered} ({pct(delivered)})</span>
            <span>Не доставлено: {undelivered} ({pct(undelivered)})</span>
          </div>

          <div className={styles.stats}>
            Чеков пробито: {checksIssuedCount} из {eligibleCount}
          </div>
        </>
      )}
    </div>
  );
}
